import { useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "../../lib/api";

const OPTIONS = [
  { value: "auto", label: "Auto — units seen on invoices" },
  { value: "unit", label: "BOX / pack only" },
  { value: "item", label: "EACH only" },
  { value: "both", label: "BOX and EACH" },
];

// How the New Order page may order this supplier product. Manual choice always overrides what invoices show;
// invoice history only says what was bought before, not what the supplier guarantees today.
export default function OrderingUnitsSelect({ product, onSaved }) {
  const [value, setValue] = useState(product.ordering_units || "auto");
  const [saving, setSaving] = useState(false);
  const change = async (v) => {
    setValue(v); setSaving(true);
    try {
      await api.put(`/supplier-products/${product.id}/ordering-units`, { ordering_units: v });
      toast.success(`Order as: ${OPTIONS.find((o) => o.value === v).label}`);
      onSaved?.(v);
    } catch (e) { toast.error(errorMessage(e)); setValue(product.ordering_units || "auto"); } finally { setSaving(false); }
  };
  return (
    <label className="inline-flex items-center gap-2 text-xs text-slate-600" data-testid="ordering-units">
      Order as
      <select value={value} disabled={saving} onChange={(e) => change(e.target.value)} className="rounded-md border border-slate-200 bg-white px-2 py-1 text-xs font-medium text-slate-800" data-testid="ordering-units-select">
        {OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      {value !== "auto" && <span className="text-[11px] text-slate-400" data-testid="ordering-units-note">manual — overrides invoice history; prices still come from invoices only</span>}
    </label>
  );
}
